/** IO KeyboardKey. */
export const IO_KEYBOARD_KEY = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  F: 'F',
  G: 'G',
  H: 'H',
  I: 'I',
  J: 'J',
  K: 'K',
  L: 'L',
  M: 'M',
  N: 'N',
  O: 'O',
  P: 'P',
  Q: 'Q',
  R: 'R',
  S: 'S',
  T: 'T',
  U: 'U',
  V: 'V',
  W: 'W',
  X: 'X',
  Y: 'Y',
  Z: 'Z',

  F1: 'F1',
  F2: 'F2',
  F3: 'F3',
  F4: 'F4',
  F5: 'F5',
  F6: 'F6',
  F7: 'F7',
  F8: 'F8',
  F9: 'F9',
  F10: 'F10',
  F11: 'F11',
  F12: 'F12',

  NUM0: '0',
  NUM1: '1',
  NUM2: '2',
  NUM3: '3',
  NUM4: '4',
  NUM5: '5',
  NUM6: '6',
  NUM7: '7',
  NUM8: '8',
  NUM9: '9',

  ENTER: 'Enter',
  ESCAPE: 'Escape',
  CONTEXT_MENU: 'ContextMenu',
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',

  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',

  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',

  TAB: 'Tab',

  DOT: '.',
  COMMA: ',',
} as const;
